import { Extension } from '@tiptap/vue-3'
import { TextSelection } from '@tiptap/pm/state'

import type { CommandProps } from '@tiptap/vue-3'

// Tell TypeScript about our custom command
declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    selectWord: {
      selectWord: () => ReturnType
    }
  }
}

const SelectWord = Extension.create({
  name: 'selectWord',

  addCommands() {
    return {
      selectWord:
        (): ((props: CommandProps) => boolean) =>
        ({ state, tr, dispatch }) => {
          const { $from } = state.selection

          // Don’t override an existing selection
          if (!state.selection.empty) return false

          const start = $from.start()
          const text = $from.parent.textContent
          const pos = $from.parentOffset

          // Find word boundaries using regex
          const left = text.slice(0, pos).search(/\b\w+$/)
          const rightOffset = text.slice(pos).search(/\W/)
          const right = rightOffset === -1 ? text.length : pos + rightOffset

          const from = start + (left === -1 ? pos : left)
          const to = start + right

          const selection = TextSelection.create(state.doc, from, to)
          tr.setSelection(selection)

          if (dispatch) {
            dispatch(tr)
          }

          return true
        },
    }
  },
})

export default SelectWord
